import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type CheckDepositProps = RowProps;

export const CheckDeposit = forwardRef<CheckDepositProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, quotas, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.check_deposit.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.check_deposit.value',
        },
        {
          fixed: toFixed(fees.additionalCheckDeposit),
          limit: quotas.checkDepositMonthQuota.limit,
          variable: toVariable(fees.additionalCheckDeposit),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
